import { User } from 'model/User';
import { Partner } from 'model/Partner';
import { Ledger, LedgerMember } from 'model/Ledger';
import { WorkProcess } from 'model/WorkProcess';
import { WorkResource } from 'model/WorkResource';
import { ResourceParam } from 'model/Resource';

export const reportMemberStatusList = [
  { value: 1, label: '出勤' },
  { value: 2, label: '欠勤' },
];

export const reportContractTypeList = [
  { value: 1, label: '常用' },
  { value: 2, label: '請負' },
];

export type ReportMemberStatus = (typeof reportMemberStatusList)[number]['value'];

export type ReportContractType = (typeof reportContractTypeList)[number]['value'];

export type ReportWorkResource = {
  id: WorkResource['id'];
  value?: number;
  text?: string;
  unitPrice?: number;
};

export type ReportMember = {
  id: number;
  reportId: Report['id'];
  memberId: number;
  status: ReportMemberStatus;
  inDatetime: number | null;
  outDatetime: number | null;
  overTime?: number;
  overTimeCost?: number;
};

export type ReportMemberUser = ReportMember & Partial<User>;

export type ReportMemberPartner = ReportMember & {
  count: number;
  name?: string;
};

export type Report = {
  id: number;
  ledgerId: Ledger['id'];
  dateCode: number;
  startDatetime: number;
  endDatetime: number;
  contractType: ReportContractType;
  memberUserIds: User['id'][];
  memberPartnerIds: Partner['id'][];
  summary: string;
  workProcessId: number;
  workResources: ReportWorkResource[];
  resourceCode: string;
  memberUsers?: ReportMemberUser[];
  memberPartners?: ReportMemberPartner[];
  ledger?: Ledger;
  leader?: User;
  leaders?: LedgerMember[];
  safetyOfficer?: User;
  safetyOfficers?: LedgerMember[];
  workProcess?: WorkProcess;
  resources?: ResourceParam[];
  costs?: { type: WorkResource['type'] | 'user' | 'partner', cost: number }[];
  fixed: boolean;
  enableEdit ?: boolean;
};
